import {Button, Col, Input, Row, Select, SelectProps, Space, message} from "antd";
import {StyledAvailabiltyFormWrapper} from "../../availability.style";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {
  MinimumNoticeFormSchema,
  MinimumNoticeFormValuesType,
} from "../../availability-validation-schema";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {useAddMinimumNoticePeriod} from "../../../../../react-query-hooks/availability";

export function MinimumNoticePeriod({noticePeriod}: {noticePeriod: number}) {
  const bookingIntervalOptions: SelectProps["options"] = [
    {
      value: "0",
      label: "None",
    },
    {
      value: "30",
      label: "30 minutes",
    },

    {
      value: "60",
      label: "1 hour",
    },
    {
      value: "120",
      label: "2 hours",
    },
    {
      value: "180",
      label: "3 hours",
    },
    {
      value: "240",
      label: "4 hours",
    },
    {
      value: "300",
      label: "5 hours",
    },
    {
      value: "custom",
      label: "Custom",
    },
  ];

  const addMinimumNoticePeriodMutation = useAddMinimumNoticePeriod();

  const handleBufferTime = () => {
    // it is hours
    if (noticePeriod > 60 && noticePeriod < 1440) {
      return {
        time: noticePeriod / 60,
        unit: "hours",
      };
    }
    // it is days
    if (noticePeriod > 1440 && noticePeriod < 525600) {
      return {
        time: noticePeriod / 1440,
        unit: "days",
      };
    }

    // it is minutes
    return {
      time: noticePeriod,
      unit: "minutes",
    };
  };
  const {
    handleSubmit,
    formState: {errors},
    watch,
    control,
    clearErrors,
    setValue,
  } = useForm<MinimumNoticeFormValuesType>({
    resolver: yupResolver(MinimumNoticeFormSchema),
    mode: "onChange",
    defaultValues: {
      bufferTime: handleBufferTime().time,
      timeUnit: handleBufferTime().unit,
    },
  });

  const onSubmit = async ({bufferTime, timeUnit}: MinimumNoticeFormValuesType) => {
    // console.log({values});

    function handleBufferTimePayloadValue() {
      if (bufferTime) {
        if (timeUnit === "hours") {
          return bufferTime * 60;
        }
        // it is days
        if (timeUnit === "days") {
          return bufferTime * 1440;
        }

        // it is minutes
        return bufferTime;
      } else {
        message.error("No time selected");
      }
    }

    const payloadValue = handleBufferTimePayloadValue();

    if (payloadValue) {
      const payload = {
        notice_period: payloadValue,
      };

      addMinimumNoticePeriodMutation.mutate(payload, {
        onSuccess() {
          message.success("Your minimum notice period has been updated successfully!");
        },
      });
    }
  };
  return (
    <StyledAvailabiltyFormWrapper>
      <div>
        <Space size={16} direction="vertical" style={{display: "flex"}}>
          <p
            style={{
              fontSize: "1.6rem",
              fontWeight: 600,
            }}
          >
            Minimum notice
          </p>
          <p
            style={{
              fontSize: "1.6rem",
              fontWeight: 400,
            }}
          >
            Set a minimum notice period for your bookings. Your customers can only book
            calls at least this far in advance on the day of the session
          </p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row gutter={[10, 24]}>
              <Col span={24} sm={12}>
                <Controller
                  control={control}
                  name="bufferTime"
                  render={({field: {onChange, value}}) => (
                    <>
                      <Input
                        size="large"
                        placeholder="Select time"
                        status={errors.bufferTime && "error"}
                        value={value}
                        onChange={onChange}
                        style={{width: 282}}
                      />

                      {errors.bufferTime?.message && (
                        <div role="alert" className="ant-form-item-explain-error">
                          {errors.bufferTime?.message}
                        </div>
                      )}
                    </>
                  )}
                />
              </Col>
              <Col span={24} sm={12}>
                <Controller
                  control={control}
                  name="timeUnit"
                  render={({field: {onChange, value}}) => (
                    <>
                      <Select
                        size="large"
                        // defaultValue="lucy"
                        value={value}
                        style={{width: 282}}
                        onChange={(v) => {
                          clearErrors("bufferTime");
                          // setValue("bufferTime", undefined);
                          onChange(v);
                        }}
                        options={[
                          {
                            value: "minutes",
                            label: "Minutes",
                          },
                          {
                            value: "hours",
                            label: "Hours",
                          },
                          {
                            value: "days",
                            label: "Days",
                          },
                        ]}
                        placeholder="Select a time unit"
                        status={errors.timeUnit && "error"}
                      />
                      {errors.timeUnit?.message && (
                        <div role="alert" className="ant-form-item-explain-error">
                          {errors.timeUnit?.message}
                        </div>
                      )}
                    </>
                  )}
                />
              </Col>
            </Row>
            <StyledServiceButtonWrapper style={{marginTop: "2.4rem"}}>
              <div>
                <Button
                  loading={addMinimumNoticePeriodMutation.isLoading}
                  block
                  type="primary"
                  htmlType="submit"
                  size="small"
                  disabled={
                    Object.keys(errors).length > 0 || Object.values(watch()).length < 1
                  }
                >
                  Save changes
                </Button>
              </div>
              {/* <div>
                <Button
                  onClick={() => reset()}
                  block
                  size="small"
                  type="text"
                  danger
                >
                  Discard
                </Button>
              </div> */}
            </StyledServiceButtonWrapper>
          </form>
        </Space>
      </div>
    </StyledAvailabiltyFormWrapper>
  );
}
